// extracted by mini-css-extract-plugin
export default {"chipButtonsWrapper":"src-signer-app-signature-modal-common-chip-buttons-wrapper-module__chipButtonsWrapper--5x1pk"};